import { render, staticRenderFns } from "./bankPage.vue?vue&type=template&id=07bc8cdf&scoped=true"
import script from "./bankPage.vue?vue&type=script&lang=js"
export * from "./bankPage.vue?vue&type=script&lang=js"
import style0 from "./bankPage.vue?vue&type=style&index=0&id=07bc8cdf&prod&lang=stylus"
import style1 from "./bankPage.vue?vue&type=style&index=1&id=07bc8cdf&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bc8cdf",
  null
  
)

export default component.exports